import classNames from "classnames";
import React from "react";

interface Props {
  /**
   * The icon to display. E.g. `<Icon icomoon={Icomoon.plus2} />`.
   * N.B. You can also use an Icomoon classname `<Icon icomoon={"icon-earth" as Icomoon} />`,
   * but it may not be part of our bundle (this is a WIP!)
   */
  icomoon: Icomoon;

  /**
   * Additional class for the icon element
   */
  className?: string;

  title?: string;
}

/**
 * Simple component to display an icon. Currently, only selected Icomoon icons are supported.
 *
 * To implement you need to use the Icomoon enum eg, `<Icon icomoon={Icomoon.checkmark} />`
 *
 * @status stable
 */
export const Icon = ({ icomoon, className, ...props }: Props) => {
  return (
    <i className={classNames("icon", "icomoon", className, icomoon)} {...props} />
  );
};

/**
 * Icons that can be used with our Icomoon bundle.
 *
 * N.B. packages/ui can't depend on armstrong-react as it causes issues.
 * This is a copy of the Icon.Icomoon export, keeping only the entries that get used in this package.
 * For the original, see `source/utilities/icons.ts` in https://github.com/travellocal/armstrong-react
 */
/**
 * Icons that can be used with our Icomoon bundle.
 *
 * N.B. packages/ui can't depend on armstrong-react as it causes issues.
 * This is a copy of the Icon.Icomoon export, keeping only the entries that get used in this package.
 * For the original, see `source/utilities/icons.ts` in https://github.com/travellocal/armstrong-react
 */
export enum Icomoon {
  airplane = "icon-airplane",
  alarm = "icon-alarm",
  arrowUp3 = "icon-arrow-up3",
  arrowDown3 = "icon-arrow-down3",
  arrowLeft3 = "icon-arrow-left3",
  arrowRight3 = "icon-arrow-right3",
  arrowRight12 = "icon-arrow-right12",
  brush = "icon-brush",
  calendar = "icon-calendar",
  cash2 = "icon-cash2",
  cross2 = "icon-cross2",
  checkmark3 = "icon-checkmark3",
  drawer3 = "icon-drawer3",
  filePdf = "icon-file-pdf",
  hammerWrench = "icon-hammerWrench",
  info = "icon-info",
  link = "icon-link",
  location = "icon-location",
  minus2 = "icon-minus2",
  pencil = "icon-pencil",
  plus2 = "icon-plus2",
  popout = "icon-popout",
  power2 = "icon-power2",
  starFull = "icon-star-full",
  starHalf = "icon-star-half",
  starEmpty = "icon-star-empty",
  starEmpty3 = "icon-star-empty3",
  starFull2 = "icon-star-full2",
  tag = "icon-tag",
  user = "icon-user",
  users = "icon-users",
  history = "icon-history",
  undo2 = "icon-undo2"
}
